import { FilterCheckboxGroup, MainFilter } from 'components/tables/list-table/ListTableTypes.tsx';
import { PaginationProps } from 'types/paginationAndFilter.ts';

export type RsqlLogicalOperator = ';' | ',';

export const RSQL_AND: RsqlLogicalOperator = ';';

export type PaginatedFieldPassiveFilter<T extends string> = {
    filterId: T;
    filters: PaginationProps['filters'];
    filterOperator: RsqlLogicalOperator;
};

type QuickFilterTyped<IdType extends string> = FilterCheckboxGroup & {
    id?: IdType;
};
type MainFilterTyped<IdType extends string, GroupType extends string> = MainFilter & {
    id?: IdType;
    group?: GroupType;
};

export function filterQuickFilters<IdType extends string>(filters: QuickFilterTyped<IdType>[], filterIds?: IdType[]) {
    return filters.filter((filter) => {
        if (!filterIds) {
            return true;
        } else {
            return filter.id == undefined || !filterIds.includes(filter.id);
        }
    });
}

export function filterMainFilters<IdType extends string, GroupType extends string>(
    mainFilters: MainFilterTyped<IdType, GroupType>[],
    filterGroups?: string[],
    filterIds?: IdType[]
) {
    return mainFilters
        .filter((filter) => {
            if (!filterGroups) {
                return true;
            } else {
                return filter.group == undefined || !filterGroups.includes(filter.group);
            }
        })
        .filter((filter) => {
            if (!filterIds) {
                return true;
            } else {
                return filter.id == undefined || !filterIds.includes(filter.id);
            }
        });
}

export function enrichDynamicFiltersWithPassiveFilter<IdType extends string, GroupType extends string>(
    mainFilters: MainFilterTyped<IdType, GroupType>[],
    passiveFilters?: PaginatedFieldPassiveFilter<string>[]
) {
    if (!passiveFilters) {
        return mainFilters;
    }
    const dynamicFilters = mainFilters
        .filter((filter) => 'paginated' in filter)
        .filter((filter) => filter.paginated !== undefined);
    passiveFilters.forEach((filter) => {
        const dynamicFilter = dynamicFilters.find((it) => it.id == filter.filterId);
        if (dynamicFilter && dynamicFilter.paginated) {
            dynamicFilter.paginated.filters = dynamicFilter.paginated.filters
                ? `${dynamicFilter.paginated.filters}${filter.filterOperator}${filter.filters}`
                : filter.filters;
        }
    });
    return mainFilters;
}
